
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Product.css';
import videoSource from '../Assets/product vide.mp4';
import productImage1 from '../Assets/lora.jpg';
import productImage2 from '../Assets/fuel fleet.jpeg';
import productImage3 from '../Assets/gate.png';
import productImage4 from '../Assets/rfid.jpeg';
import productImage5 from '../Assets/rfid reader.jpg';
import productImage6 from '../Assets/asset.jpeg';
import productImage7 from '../Assets/water quality.jpg';
import productImage8 from '../Assets/alarm.jpeg';
import productImage9 from '../Assets/truck temp1.jpeg';
import productImage10 from '../Assets/cold storage1.png';
import productImage11 from '../Assets/transport.jpg';
import productImage12 from '../Assets/dataa.jpg';
import productImage13 from '../Assets/remote p.jpg';

const ProductPage = () => {
  return (
    <div className="product-container">
      <div className="video-background">
        <video autoPlay loop muted>
          <source src={videoSource} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-content">
          <h1>Our Amazing Products</h1>
          <p>Discover the features and benefits of our products.</p>
        </div>
      </div>

      {/* Cards section with images */}
      <div className="card-section">
        {[
          { image: productImage3, title: 'Remote Gateways', route: '/remote-gateways' },
          { image: productImage4, title: 'RFID Tag', route: '/rfid-tag' },
          { image: productImage5, title: 'RFID Reader', route: '/RFID-Reader' },
          { image: productImage6, title: 'Asset Monitoring System', route: '/Asset-Monitoring-System' },
          { image: productImage7, title: 'Metro Water Quality', route: '/Metro-Water-Quality' },
          { image: productImage8, title: 'Burgular Alarm System', route: '/Burgular-Alarm-System' },
          { image: productImage9, title: 'RF Based Temperature Monitoring For Truck', route: '/RF-Based-Temperature-Monitoring-For-Truck' },
          { image: productImage10, title: 'Temperature Monitoring For Cold Storage', route: '/Temperature-Monitoring-For-Cold-Storage' },
          { image: productImage11, title: 'Temperature Monitoring For Food and Transport', route: '/Temperature-Monitoring-For-Food-and-Transport' },
          { image: productImage1, title: 'LoRa Based Water Meter', route: '/lora-based-water-meter' },
          { image: productImage12, title: 'Data Transfer Unit', route: '/Data-transfer-unit' },
          { image: productImage13, title: 'Remote Gateway', route: '/remote-gateways' },
        ].map((product, index) => (
          <NavLink key={index} to={product.route} className="productcard">
            <img src={product.image} alt={`Product ${index + 1}`} className="card-image" />
            <div className="card-content">
              <h2>{product.title}</h2>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default ProductPage;
